/**
 * Словарик литералов/констант
 */
export default class BaseConst {
    public static readonly RESULT_OK = 200;
    public static readonly RESULT_POST_UNSUCCESSFUL = -32606;
    public static readonly RESULT_ANONYMOUS_USER = -32604;
    public static readonly METHOD_GET_BOARD: string = 'getBoard';
    public static readonly METHOD_GET_POSTS: string = 'getPosts';
    public static readonly METHOD_CLOSE_TOPIC: string = 'closeTopic';
    public static readonly THEME_OLD: string = 'old';
    public static readonly THEME_NEW: string = 'new';
    public static readonly TYPE_DEFAULT: string = 'articles';
    public static readonly LANG_ALT: string = 'ru';
    public static readonly LANG_DEFAULT: string = 'uk';
    public static readonly MESSAGE_INFO: string = 'xarticle-info';
    public static readonly MESSAGE_RESIZE: string = 'xarticle-resize';
    public static readonly MESSAGE_REFRESH: string = 'xarticle-refresh';
    public static readonly MESSAGE_CREATE_BOARD: string = 'xarticle-create-board';
    public static readonly MESSAGE_RELOAD_BOARD: string = 'discussion-reload';
    public static readonly MESSAGE_NUMBER_OF_COMMENTS: string = 'number-of-comments';
    public static readonly SORT_ASC: number = 0;
    public static readonly SORT_DESC: number = 1;
    public static readonly COOKIE_SORT: string = 'xarticles_sort_mode';
    public static readonly COOKIE_LIFETIME: number = 60 * 60 * 24 * 30;
}
